import $ from "jquery";
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import TaxQuote from "../../quote/tax.component.jsx";
import { deletePricingTableItem, patchPricingTableItem, setGetPricingTableItem } from '../../state/pricing/actions';
import { getPricingTableId, getPricingTableItem } from '../../state/pricing/selectors';
import { PRODUCT_TYPE } from "../../state/product/Types";
import { PRICING_TABLE } from "../../utils/pricing/constants";
import ActionButton from '../button/actionbutton.component.jsx';
import Icon from "../icon/icon.component.jsx";
import ItemBulkUpdateAssignedUser from './component/ItemBulkUpdateAssignedUser.tsx';
import ItemDeleteButton from "./component/ItemDeleteButton";
const uuidv4 = require('uuid/v4')

class QuoteItemSettings extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            type: this.props.type || 'quote',
            editable: this.props.editable || false,
            fees: this.props.fees || [],
            rowId: this.props.item ? this.props.item.id : '',
            uniqueId: uuidv4(),
            quoteId: this.props.item ? this.props.item.attributes.quoteId : '',
            itemStatus: this.props.item ? this.props.item.attributes.type : '',
            taxable: this.props.item ? this.props.item.attributes.taxable : false,
            hidePrice: this.props.item ? this.props.item.attributes.hidePrice : false,
            feeApplicable: this.props.item ? this.props.item.attributes.feeApplicable : false,
            measureEditable: this.props.item ? this.props.item.attributes.measureEditable : false,
            taxId: this.props.item ? this.props.item.attributes.taxId : '',
            assignedToUserId: this.props.item ? this.props.item.attributes.assignedToUserId : '',
            setAssignedUserModal: '',
            setTaxModal: '',
            tableTax: this.props.tableTax || null,
            title: this.props.title || '',
            mainObjectId: this.props.mainObjectId || '',
            parentId: this.props.item.attributes.parentId || ''
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleClickInput = this.handleClickInput.bind(this)
        this.handleDeleteRow = this.handleDeleteRow.bind(this)
        this.save = this.save.bind(this)
        this.onEditLinkClick = this.props.onEditLinkClick || function () {
        }
        this.openSetTaxModal = this.openSetTaxModal.bind(this)
        this.closeSetTaxModal = this.closeSetTaxModal.bind(this)
        this.openSetAssignedUserModal = this.openSetAssignedUserModal.bind(this)
        this.closeSetAssignedUserModal = this.closeSetAssignedUserModal.bind(this)

    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            fees: nextProps.fees || [],
            taxId: nextProps.item?.attributes.taxId || '',
            tableTax: nextProps.tableTax || null,
            mainObjectId: nextProps.mainObjectId || '',
            rowId: nextProps.item?.id || '',
            quoteId: nextProps.item?.attributes.quoteId || '',
            itemStatus: nextProps.item?.attributes.type || '',
            taxable: nextProps.item?.attributes.taxable || false,
            hidePrice: nextProps.item?.attributes.hidePrice || false,
            feeApplicable: nextProps.item?.attributes.feeApplicable || false,
            measureEditable: nextProps.item?.attributes.measureEditable || false,
            assignedToUserId: nextProps.item?.attributes.assignedToUserId || '',
        })
    }

    save() {
        this.props.dispatch(patchPricingTableItem(this.props.itemId, this.props.mainObjectId, this.props.type, {
            status: this.state.itemStatus,
            taxable: this.state.taxable,
            hidePrice: this.state.hidePrice,
            feeApplicable: this.state.feeApplicable,
            measureEditable: this.state.measureEditable,
            mainObjectId: this.state.mainObjectId,
        }, true, true))
         this.props.onChange()
    }

    handleClickInput(event) {
        $('#' + this.state.uniqueId).dropdown('toggle')
    }

    handleClickButton(name, value) {
        return function (event) {
            event.preventDefault()
            this.setState({
                [name]: value,
            }, () => this.save())
        }.bind(this)
    }

    handleFormChange(event) {
        event.preventDefault()
    }

    handleEditLinkClick(itemId) {
        return function (event) {
            event.preventDefault()
            this.onEditLinkClick(itemId)
        }.bind(this)
    }


    async handleDeleteRow(event) {
        event.preventDefault()
        this.props.dispatch(deletePricingTableItem(this.props.itemId, this.props.mainObjectId, this.props.type))
    }

    openSetTaxModal(e) {
        this.setState({
            setTaxModal: <TaxQuote
                taxId={this.state.taxId}
                type={this.props.type}
                mainObject={this.props.type}
                objectId={this.state.rowId}
                mainObjectId={this.state.mainObjectId}
                itemId={this.state.rowId}
                onClose={() => this.closeSetTaxModal()}
                tableTax={this.state.tableTax}
                mainTaxesOnly={false} />
        })
        e.preventDefault()
    }

    openSetAssignedUserModal(event) {
        this.setState({
            setAssignedUserModal: <ItemBulkUpdateAssignedUser
                assignedToUserId={this.state.assignedToUserId}
                objectId={this.state.mainObjectId}
                mainObject={this.props.type}
                itemIdList={new Set([this.state.rowId])}
                onClose={(assignedToUserId) => this.closeSetAssignedUserModal(assignedToUserId)}
            />
        })
        event.preventDefault()
    }

    closeSetAssignedUserModal(assignedToUserId) {
        if (assignedToUserId) {
            this.setState({
                setAssignedUserModal: '',
                assignedToUserId: assignedToUserId,
            })
        } else {
            this.setState({
                setAssignedUserModal: ''
            })
        }
    }

    closeSetTaxModal() {
            this.setState({
                setTaxModal: ''
            })
        }


    render() {
        if (!this.state.itemStatus || !this.state.editable) {
            return ''
        }

        if(this.state.parentId !== "") {
            return(<ItemDeleteButton 
                className={this.state.className}
                title={this.state.title}
                id={this.state.uniqueId}
                handleDeleteRowCallback={(e) => this.handleDeleteRow(e)}
            />) 
        }

        const isQuote = this.props.type === 'quote'
        const isPriceList = this.props.type === 'price-list'
        const isOrder = this.props.type === 'order'
        const isPricingTable = this.props.type === PRICING_TABLE
        return <span className={"" + this.state.className}>
            <form>
                <button title={this.state.title} id={this.state.uniqueId} type="button"
                    className="btn btn-sm btn-outline-primary px-1" data-toggle="dropdown"
                    aria-haspopup="false" aria-expanded="false">
                    <Icon value={'ellipsis-h'} className={"px-1"} />
                </button>
                <div className="dropdown-menu">
                    {!isPricingTable &&
                        <>
                            <button className={"dropdown-item btn-sm py-0"} type={"button"}
                                onClick={this.handleClickButton("itemStatus", "active")}>
                                <input type="radio"
                                    id={"itemStatusActive" + this.state.uniqueId}
                                    name="itemStatus"
                                    value="active"
                                    checked={this.state.itemStatus === 'active'}
                                    onChange={this.handleFormChange}
                                    onClick={this.handleClickInput}
                                    className="align-middle"
                                />
                                <label className={"ml-2 my-1"} htmlFor={"itemStatusActive" + this.state.uniqueId}>
                                    <FormattedMessage
                                        id="quote.add_item_modal.configure.item_status.active_label"
                                        defaultMessage="Active"
                                    />
                                </label>
                            </button>
                            {isQuote || isPriceList ? <button className="dropdown-item btn-sm py-0" type="button"
                                onClick={this.handleClickButton("itemStatus", "option-for-customer")}>
                                <input type="radio"
                                    id={"itemStatusOptionForCustomer" + this.state.uniqueId}
                                    name="itemStatus"
                                    value="option-for-customer"
                                    checked={this.state.itemStatus === 'option-for-customer'}
                                    onChange={this.handleFormChange}
                                    onClick={this.handleClickInput}
                                    className="align-middle"
                                />
                                <label className="ml-2 my-1" htmlFor={"itemStatusOptionForCustomer" + this.state.uniqueId}>
                                    <FormattedMessage
                                        id="quote.add_item_modal.configure.item_status.optional_for_customer_label"
                                        defaultMessage="Optional Item"
                                    />
                                </label>
                            </button> : ''}
                            {isQuote || isPriceList ? <button className="dropdown-item btn-sm py-0" type="button"
                                onClick={this.handleClickButton("itemStatus", "multiple-choice")}>
                                <input type="radio"
                                    id={"itemStatusMultipleChoice" + this.state.uniqueId}
                                    name="itemStatus"
                                    value="multiple-choice"
                                    checked={this.state.itemStatus === 'multiple-choice' || this.state.itemStatus === 'choice-selected'}
                                    onChange={this.handleFormChange}
                                    onClick={this.handleClickInput}
                                    className="align-middle"
                                />
                                <label className="ml-2 my-1" htmlFor={"itemStatusMultipleChoice" + this.state.uniqueId}>
                                    <FormattedMessage
                                        id="quote.add_item_modal.configure.item_status.multiple_choice_label"
                                        defaultMessage="Multiple Choice"
                                    />
                                </label>
                            </button> : ''}
                            {isQuote ? <button className="dropdown-item btn-sm py-0" type="button"
                                onClick={this.handleClickButton("itemStatus", "provided-by-customer")}>
                                <input type="radio"
                                    id={"itemStatusProvidedByCustomer" + this.state.uniqueId}
                                    name="itemStatus"
                                    value="provided-by-customer"
                                    checked={this.state.itemStatus === 'provided-by-customer'}
                                    onChange={this.handleFormChange}
                                    onClick={this.handleClickInput}
                                    className="align-middle"
                                />
                                <label className="ml-2 my-1" htmlFor={"itemStatusProvidedByCustomer" + this.state.uniqueId}>
                                    <FormattedMessage
                                        id="quote.add_item_modal.configure.item_status.provided_by_customer_label"
                                        defaultMessage="Provided by customer"
                                    />
                                </label>
                            </button> : ''}
                            <button className="dropdown-item btn-sm py-0" type="button"
                                onClick={this.handleClickButton("itemStatus", "included")}>
                                <input type="radio"
                                    id={"itemStatusIncluded" + this.state.uniqueId}
                                    name="itemStatus"
                                    value="included"
                                    checked={this.state.itemStatus === 'included'}
                                    onChange={this.handleFormChange}
                                    onClick={this.handleClickInput}
                                    className="align-middle"
                                />
                                <label className="ml-2 my-1" htmlFor={"itemStatusIncluded" + this.state.uniqueId}>
                                    <FormattedMessage
                                        id="quote.add_item_modal.configure.item_status.included_label"
                                        defaultMessage="Included"
                                    />
                                </label>
                            </button>
                            <div className="dropdown-divider" />
                            <button className="dropdown-item btn-sm" type="button"
                                onClick={this.handleClickButton("taxable", !this.state.taxable)}>
                                <input type="checkbox"
                                    id={"taxable" + this.state.uniqueId}
                                    name="taxable"
                                    checked={this.state.taxable}
                                    onChange={this.handleFormChange}
                                    className="align-middle"
                                />
                                <label className="ml-2 my-1" htmlFor={"taxable" + this.state.uniqueId}>
                                    <FormattedMessage
                                        id="quote.add_item_modal.taxable_label"
                                        defaultMessage="Taxable"
                                    />
                                </label>
                            </button>
                            <button className="dropdown-item btn-sm" type="button"
                                onClick={this.handleClickButton("hidePrice", !this.state.hidePrice)}>
                                <input type="checkbox"
                                    id={"hidePrice" + this.state.uniqueId}
                                    name="hidePrice"
                                    checked={this.state.hidePrice}
                                    onChange={this.handleFormChange}
                                    className="align-middle"
                                />
                                <label className="ml-2 my-1" htmlFor={"hidePrice" + this.state.uniqueId}>
                                    <FormattedMessage
                                        id="quote.add_item_modal.hide_price_label"
                                        defaultMessage="Hide price"
                                    />
                                </label>
                            </button>
                            {this.state.fees && this.state.fees.some(fee => fee.attributes.rateType != "flat-rate") ? <button className="dropdown-item btn-sm" type="button"
                                onClick={this.handleClickButton("feeApplicable", !this.state.feeApplicable)}>
                                <input type="checkbox"
                                    id={"feeApplicable" + this.state.uniqueId}
                                    name="feeApplicable"
                                    checked={!this.state.feeApplicable}
                                    onChange={this.handleFormChange}
                                    className="align-middle"
                                />
                                <label className="ml-2 my-1" htmlFor={"feeApplicable" + this.state.uniqueId}>
                                    <FormattedMessage
                                        id="quote.add_item_modal_fee_exempt_label"
                                        defaultMessage="Fee Exempt"
                                    />
                                </label>
                            </button> : null}
                            {isQuote || isPriceList ? <button className="dropdown-item btn-sm" type="button"
                                onClick={this.handleClickButton("measureEditable", !this.state.measureEditable)}>
                                <input type="checkbox"
                                    id={"measureEditable" + this.state.uniqueId}
                                    name="measureEditable"
                                    checked={this.state.measureEditable}
                                    onChange={this.handleFormChange}
                                    className="align-middle"
                                    disabled={this.props.item?.attributes.itemObject.attributes.type === PRODUCT_TYPE.BUNDLE}
                                />
                                <label className="ml-2 my-1" htmlFor={"measureEditable" + this.state.uniqueId}>
                                    <FormattedMessage
                                        id="quote.add_item_modal.configure.item_status.editable_quantity_label"
                                        defaultMessage="Editable quantity"
                                    />
                                </label>
                            </button> : ''}
                            <div className="dropdown-divider" />
                            <button className="dropdown-item btn-sm py-2" type="button" onClick={this.openSetTaxModal}>
                                {this.props.item && <label className={'mb-0 d-flex align-items-center'}>
                                    <Icon value={'edit'} className={'mr-1'} />
                                    <span>
                                        {this.props.item.attributes.taxName}
                                    </span>
                                    <span className="ml-1">
                                        {this.props.item.attributes.totalTaxRate}%
                                    </span>
                                </label>}
                            </button>
                            <div className="dropdown-divider" />
                            {isOrder && <button className="dropdown-item btn-sm py-2" type="button" onClick={this.openSetAssignedUserModal}>
                                {this.props.item && <label className={'mb-0 d-flex align-items-center'}>
                                    <Icon value={'edit'} className={'mr-1'} />
                                    <span>
                                        <FormattedMessage
                                            id="quote.add_item_modal.configure.item_status.order_row_user"
                                            defaultMessage="Assigned User"
                                        />
                                    </span>
                                </label>}
                            </button>}
                        </>

                    }
                    {isPricingTable && 
                        <>
                            <button className="dropdown-item btn-sm" type="button"
                                onClick={this.handleClickButton("taxable", !this.state.taxable)}>
                                <input type="checkbox"
                                    id={"taxable" + this.state.uniqueId}
                                    name="taxable"
                                    checked={this.state.taxable}
                                    onChange={this.handleFormChange}
                                    className="align-middle"
                                />
                                <label className="ml-2 my-1" htmlFor={"taxable" + this.state.uniqueId}>
                                    <FormattedMessage
                                        id="quote.add_item_modal.taxable_label"
                                        defaultMessage="Taxable"
                                    />
                                </label>
                            </button>
                            <div className="dropdown-divider" />
                            <button className="dropdown-item btn-sm py-2" type="button" onClick={this.openSetTaxModal}>
                                {this.props.item && <label className={'mb-0 d-flex align-items-center'}>
                                    <Icon value={'edit'} className={'mr-1'} />
                                    <span>
                                        {this.props.item.attributes.taxName}
                                    </span>
                                    <span className="ml-1">
                                        {this.props.item.attributes.totalTaxRate}%
                                    </span>
                                </label>}
                            </button>
                            <div className="dropdown-divider" />
                        </>
                    }
                    {
                        <>
                            <button className="dropdown-item btn-sm py-2" type="button"
                                onClick={this.handleEditLinkClick(this.state.rowId)}>
                                <Icon value={"edit"} className="mr-1" />
                                <label className="mb-0">
                                    <FormattedMessage
                                        id="quote.add_item_modal.edit_label"
                                        defaultMessage="Edit"
                                    />
                                </label>
                            </button>
                            {this.props.shouldEditQuantity && <ActionButton className="dropdown-item btn-sm btn-danger text-danger py-2" type="button"
                                onClick={ this.handleDeleteRow }>
                                <Icon value={"trash"} className="mr-1" />
                                <label className="mb-0">
                                    <FormattedMessage
                                        id="quote.add_item_modal.delete_label"
                                        defaultMessage="Delete"
                                    />
                                </label>
                            </ActionButton>}
                        </>
                    }
                </div>
            </form>
            {this.state.setTaxModal}
            {this.state.setAssignedUserModal}
        </span>

    }

}

const mapState = (state, props) => {
    const id = props.itemId
    const objectId = props.mainObjectId
    const item = getPricingTableItem(state, id, objectId)
    return {
        ...props,
        item: item,
        pricingTableId: getPricingTableId(state, objectId)
    }
}
const mapDispatch = (dispatch) => { 
    return {
    setGetPricingTableItem : setGetPricingTableItem, 
    deletePricingTableItem : deletePricingTableItem,
    dispatch : dispatch }

}
export default connect(mapState, mapDispatch)(injectIntl(QuoteItemSettings))





// WEBPACK FOOTER //
// ./src/common/quote/itemsettings.component.jsx